<template>
  <div :class="['szw-flex szw-h-fit', { 'szw-justify-center': align === 'center' }, props.animate ? 'szw-w-full' : 'szw-w-fit']" ref="containerRef">
    <span v-if="!shouldAnimate" :class="classesMemo" ref="labelRef">{{ props.text }}</span>

    <vue3-marquee v-else :duration="props.duration" :class="'szw-overflow-hidden'">
      <span :class="classesMemo" ref="labelRef" data-test="marquee">{{ props.text }}</span>
    </vue3-marquee>
  </div>
</template>

<script setup>
import { ref, watch, computed, onMounted, onBeforeUnmount, nextTick, inject } from 'vue'
import { Vue3Marquee } from 'vue3-marquee'
import debounce from 'lodash/debounce'

const props = defineProps({
  text: {
    type: String,
    default: () => ''
  },
  classes: {
    type: String,
    default: () => ''
  },
  duration: {
    type: Number,
    default: () => 30
  },
  animate: {
    type: Boolean,
    default: () => true
  },
  align: {
    type: String,
    default: ''
  }
})

/** @type {Ref<HTMLSpanElement>} */
const labelRef = ref(null)
/** @type {Ref<HTMLDivElement>} */
const containerRef = ref(null)
const shouldAnimate = ref(false)

const activeSize = inject('activeSize', ref(640))

const classesMemo = computed(() => ['szw-text-nowrap szw-h-fit szw-w-fit', props.classes, { 'szw-mr-6': shouldAnimate.value }])

const unwatchText = watch(
  () => props.text,
  async () => {
    await handleLabelAnimation()
  }
)

const unwatchActiveSize = watch(
  () => activeSize.value,
  async () => {
    await handleLabelAnimation()
  }
)

const handleLabelAnimation = async () => {
  await nextTick(() => {
    shouldAnimate.value = props.animate && containerRef.value && containerRef.value.offsetWidth < labelRef.value.offsetWidth
  })
}

const handleResize = debounce(async () => {
  await handleLabelAnimation()
}, 300)

const setupResizeListener = () => {
  window.addEventListener('resize', handleResize)
}

onMounted(async () => {
  await handleLabelAnimation()
  setupResizeListener()
})

onBeforeUnmount(() => {
  window.removeEventListener('resize', handleResize)
  unwatchText()
  unwatchActiveSize()
})
</script>
